module.exports = __webpack_public_path__ + "img/map.45b502c3.svg";